import { CuratedModel } from '../types/content';
import { OpenRouterModel } from './api';
import { openRouterPrefixCountry } from '../data/geography';

export type AccessFilter = 'all' | 'open' | 'free' | 'paid' | 'frontier';

export const ACCESS_OPTIONS: Array<[AccessFilter, string]> = [
  ['all', 'All'],
  ['open', 'Open-weight'],
  ['free', 'Free to use'],
  ['paid', 'Paid API'],
  ['frontier', 'Frontier tier'],
];

const FRONTIER_LABS = new Set(['OpenAI', 'Anthropic', 'Google DeepMind', 'xAI']);
const FRONTIER_PREFIX = new Set(['openai', 'anthropic', 'google', 'x-ai']);
const OPEN_FAMILY = /(gpt-oss|llama|gemma|qwen|deepseek|kimi|glm|minimax|hermes|phi-|mistral-small|mistral-nemo|mixtral|devstral|magistral-small|olmo|falcon|jamba|nemotron|granite|sarvam|ernie|hunyuan|step|internlm|yi-)/i;

export function curatedMatches(m: CuratedModel, f: AccessFilter): boolean {
  switch (f) {
    case 'all':
      return true;
    case 'open':
    case 'free':
      return m.license !== 'proprietary';
    case 'paid':
      return m.license === 'proprietary';
    case 'frontier':
      return m.license === 'proprietary' && FRONTIER_LABS.has(m.lab);
  }
}

export function orPrefix(m: OpenRouterModel): string {
  return m.id.split('/')[0] ?? '';
}

export function orCountry(m: OpenRouterModel): string | null {
  return openRouterPrefixCountry[orPrefix(m)] ?? null;
}

export function orIsOpenFamily(m: OpenRouterModel): boolean {
  return OPEN_FAMILY.test(m.id);
}

export function orMatches(m: OpenRouterModel, f: AccessFilter): boolean {
  switch (f) {
    case 'all':
      return true;
    case 'open':
      return orIsOpenFamily(m);
    case 'free':
      return m.free;
    case 'paid':
      return !m.free;
    case 'frontier':
      return FRONTIER_PREFIX.has(orPrefix(m)) && !orIsOpenFamily(m) && !m.free;
  }
}

export const ACCESS_NOTES: Record<AccessFilter, string> = {
  all: 'Every model.',
  open: 'Weights published for download.',
  free: 'Open weights, or a $0 hosted endpoint.',
  paid: 'Proprietary, or a paid hosted endpoint.',
  frontier: 'Proprietary models from OpenAI, Anthropic, Google DeepMind and xAI.',
};
